export default __webpack_public_path__ + "static/media/image16tum.ca74831c.jpg";